module.exports = __webpack_public_path__ + "static/hero-about-extended-2000x400-67abc6d3303813b6976aaa3dd21029a3.jpg";